export const TOP_NEWS_HISTORY_CONTENT_CONSTS = {
  publicationsNotExists: 'Публикации отсутствуют'
}
